export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                APP下载
              </h2>
              <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed max-w-[500px]">
                选择适合你的51吃瓜客户端，随时随地畅快吃瓜。支持安卓下载与苹果iOS安装，多种版本满足不同需求。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                <div className="bg-background-100 rounded-lg p-4 text-center border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-primary-50 flex items-center justify-center">
                    <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                  </div>
                  <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">51吃瓜app</p>
                  <p className="text-xs text-foreground-400 mb-3">完整版 · 功能全面</p>
                  <span className="inline-block px-4 py-2 bg-primary-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap cursor-pointer">
                    安卓下载
                  </span>
                </div>

                <div className="bg-background-100 rounded-lg p-4 text-center border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-accent-50 flex items-center justify-center">
                    <i className="ri-lightbulb-line text-accent-500 text-lg"></i>
                  </div>
                  <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">51吃瓜轻量版</p>
                  <p className="text-xs text-foreground-400 mb-3">精简版 · 省流省空间</p>
                  <span className="inline-block px-4 py-2 bg-accent-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap cursor-pointer">
                    安卓下载
                  </span>
                </div>

                <div className="bg-background-100 rounded-lg p-4 text-center border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-secondary-100 flex items-center justify-center">
                    <i className="ri-apple-line text-secondary-600 text-lg"></i>
                  </div>
                  <p className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">51吃瓜网app</p>
                  <p className="text-xs text-foreground-400 mb-3">苹果版 · iOS客户端</p>
                  <span className="inline-block px-4 py-2 bg-secondary-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap cursor-pointer">
                    苹果下载
                  </span>
                </div>
              </div>

              <p className="text-xs text-foreground-400">
                <i className="ri-information-line mr-1"></i>
                当前最新版本：v3.2.1 · 支持 Android 8.0+ 和 iOS 14.0+
              </p>
            </div>

            <div className="flex-1 w-full max-w-[400px] lg:max-w-none p-8 md:p-12 lg:p-0 lg:pr-14">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20entertainment%20news%20app%20interface%20with%20trending%20topics%2C%20warm%20coral%20and%20white%20color%20scheme%2C%20clean%20UI%20design%2C%20minimal%20flat%20illustration%20style%2C%20mobile%20app%20screen%20display&width=500&height=400&seq=app-mockup-01&orientation=portrait"
                alt="51吃瓜app客户端界面展示 - 支持安卓下载与苹果版"
                className="w-full h-auto object-cover rounded-lg"
                width="500"
                height="400"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}